export interface PollConfig {
    intervalMs: number;
    limit: number;
}

export const MIN_POLL_INTERVAL_MS = 5_000;
export const MAX_POLL_LIMIT = (15 * 60 * 1_000) / MIN_POLL_INTERVAL_MS; // 15 minutes

export function createDefaultPollConfig(): PollConfig {
    return {
        intervalMs: MIN_POLL_INTERVAL_MS,
        limit: MAX_POLL_LIMIT,
    };
}
